import asFedVsDryMatter from "./asFedVsDryMatter";
import lowestPhosphorusNoPrescription from "./lowestPhosphorusNoPrescription";

export const BLOG_ARTICLES = [
  lowestPhosphorusNoPrescription,
  asFedVsDryMatter,
];

export const getBlogArticleBySlug = (slug) =>
  BLOG_ARTICLES.find((article) => article.slug === slug);
